if (!customElements.get('feblilac-mobile-buybar')) {
  customElements.define(
    'feblilac-mobile-buybar',
    class FeblilacMobileBuybar extends HTMLElement {
      connectedCallback() {
        this.primaryButton = document.getElementById(this.dataset.primaryButton);
        this.priceTarget = document.getElementById(this.dataset.priceTarget);
        this.actionButton = this.querySelector('[data-mobile-buybar-button]');
        this.priceOutput = this.querySelector('[data-mobile-buybar-price]');

        if (!this.primaryButton || !this.actionButton) return;

        document.body.classList.add('fl-has-mobile-buybar');
        this.actionButton.addEventListener('click', () => {
          if (!this.primaryButton.disabled) this.primaryButton.click();
        });

        this.syncState = this.syncState.bind(this);
        this.syncState();

        this.stateObserver = new MutationObserver(this.syncState);
        this.stateObserver.observe(this.primaryButton, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true,
        });

        if (this.priceTarget) {
          this.priceObserver = new MutationObserver(this.syncState);
          this.priceObserver.observe(this.priceTarget, {
            childList: true,
            characterData: true,
            subtree: true,
          });
        }

        this.visibilityObserver = new IntersectionObserver(
          ([entry]) => this.classList.toggle('is-hidden', entry.isIntersecting),
          { threshold: 0.55 },
        );
        this.visibilityObserver.observe(this.primaryButton);
      }

      disconnectedCallback() {
        this.stateObserver?.disconnect();
        this.priceObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        if (!document.querySelector('feblilac-mobile-buybar')) {
          document.body.classList.remove('fl-has-mobile-buybar');
        }
      }

      syncState() {
        const primaryLabel = this.primaryButton.querySelector('span')?.textContent?.trim();
        if (primaryLabel) this.actionButton.textContent = primaryLabel;
        this.actionButton.disabled = this.primaryButton.disabled;

        const currentPrice =
          this.priceTarget?.querySelector('.price__sale .price-item--last') ||
          this.priceTarget?.querySelector('.price__regular .price-item--regular');
        if (currentPrice && this.priceOutput) {
          this.priceOutput.textContent = currentPrice.textContent.trim();
        }
      }
    },
  );
}
